<template>
  <b-modal hide-footer centered v-model="isVisible">
    <section class="text-center">
      <b-row no-gutters class="justify-content-center">
        <b-col cols="12" class="py-2">
          <h3 class="font-weight-bold">{{ t('loginRegisterLink') }}</h3>
          <small>
            <b-link
              @click.prevent="$emit('showmodal', 'login')"
              class="text-dark"
            >
              Tripplanner <u>{{ t('oldSignupPrivacyAndTermsOf') }} </u>
              <u>{{ t('oldSignupAgreeToTerms') }} </u>
            </b-link>
          </small>
        </b-col>
        <b-col cols="8" class="py-2">
          <b-btn pill variant="outline-info" block class="py-2">
            Google <span class="text-dark">{{ t('modalsRegisterVia') }}</span></b-btn
          >
        </b-col>
        <b-col cols="8" class="py-2">
          <b-btn pill variant="outline-info" block class="py-2">
            Facebook <span class="text-dark">{{ t('modalsRegisterVia') }}</span></b-btn
          >
        </b-col>
        <b-col cols="8" class="py-2"> {{ t('modalsOr') }} </b-col>
        <b-col cols="8" class="py-2">
          <b-btn
            pill
            variant="outline-warning"
            block
            class="py-2"
            @click="$emit('showmodal', 'signupForm')"
          >
            {{ t('signupRegisterViaEmail') }}
          </b-btn>
        </b-col>
        <b-col cols="8" class="py-2">
          <b-link @click.prevent="$emit('showmodal', 'login')">
            <span class="turquoise">{{ t('loginSubmitButton') }}</span> {{ t('signupAlreadyHaveAccount') }}
          </b-link>
        </b-col>
      </b-row>
    </section>
  </b-modal>
</template>
<script>
import { translationMixin } from '@/mixins/translationMixin';

export default {
  mixins: [translationMixin],
  props: ["value"],
  computed: {
    isVisible: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
  },
};
</script>
<style>
</style>